/**
 * Kill-switch do PIX na escolha de forma de pagamento.
 *
 * Boticário pediu para ocultar enquanto o PIX estiver instável.
 * Acordo já fechado em PIX (sucesso / 2ª via só com PIX) continua visível.
 *
 * Religar: VUE_APP_PIX_PAYMENT=on no .env e nas variáveis de CI
 * (ENV_HOMOLOG / ENV_PRODUCTION). Qualquer outro valor, inclusive vazio,
 * mantém o PIX oculto.
 */
export function isPixPaymentEnabled() {
  const flag = String(process.env.VUE_APP_PIX_PAYMENT || '').trim().toLowerCase();
  return flag === 'on' || flag.startsWith('on');
}

export function isPixPaymentMethod(method) {
  const raw = String(method || '').trim().toUpperCase();
  return raw === 'P' || raw === 'PIX';
}
